import globalEventDistributor from '../helpers/globalEventDistributor';

export const SET_MAINTENANCE_MODE = 'SET_MAINTENANCE_MODE';

export const setMaintenanceMode = (isMaintenanceMode = true) => globalEventDistributor.dispatch({
    isMaintenanceMode, type: SET_MAINTENANCE_MODE
});
